/*!
 * @copyright
 * Copyright(c) 2018 SICK AG
 */
/**
 * base class of an Actor
 * an Actor ca be used to animate or set Object3D attributes or shader uniforms
 * if an Actor is expired the stage will remove the actor automatically
 */
export class Actor {
    constructor() {
        this._expired = false;
    }
    /**
     * checks if the actor is expired
     */
    isExpired() {
        return this._expired;
    }
    /**
     * sets this actor to expired
     */
    discontinue() {
        this._expired = true;
    }
}
//# sourceMappingURL=Actor.js.map